import React, { Component } from 'react'
import data from "./store/xmas-locations.json"
import { XYFrame } from "semiotic"


// const fatal = data.filter(({severity}) => severity === "Fatal")
// const serious = data.filter(({severity}) => severity === "Serious Injury")
// const minor = data.filter(({severity}) => severity === "Minor Injury")
// const noninjury = data.filter(({severity}) => severity === "Non-injury")

class StepChart extends Component {

  render(){

    const width = Math.min(window.innerWidth - 20, 400);
    const height = 1.25 * width;

    const common = {
      xExtent: [0, 924876],
      yExtent: [0, 1426115],
      size: [width,height],
      xAccessor: d => d.x,
      yAccessor: d => d.y,
      hoverAnnotation: true,
      tooltipContent: d => { 
        let extra = {};
        if (d.voronoiX < 100) {
          extra = {left: (-d.voronoiX - 10) + "px"}
        } else if (d.voronoiX > width - 100) {
          extra = {left: (-180 + width - d.voronoiX) + "px"}
        }

        if (d.voronoiY < 100) {
          extra['top'] = '100px'
        }

        return (
          <div>
            <div className="tooltip-content" style={{
              ...extra,
              backgroundColor: d.color,
              color: d.severity === 'Fatal' ? 'white' : '#111'
            }}>
            <div style={{width: "100%", display: "flex",
              justifyContent: "space-between",
              paddingBottom: "6px",
              marginBottom: "6px",
              borderBottom: `1px solid ${d.severity === 'Fatal' ? 'white' : '#111'}`}}><div>Severity</div>
              <div style={{whiteSpace: "nowrap", marginLeft: "1em"}}> {d.severity}</div></div>
            <div style={{width: "100%", display: "flex", justifyContent: "space-between"}}><div>Year</div> <div> {d.year}</div></div>
            <div style={{width: "100%", display: "flex", justifyContent: "space-between"}}><div>Type</div>
            <div style={{whiteSpace: "nowrap", marginLeft: "1em"}}> {d.vehicles}</div></div>
          </div>
        </div>
        )},
      pointStyle: d => ({fill: d.color})
    }
    return (<div>
      <XYFrame {...common} points={data}
      legend={{
        position: 'left',
        title: 'Crash Severity',
        legendGroups: [
          {
            styleFn: d => ({ fill: d.color}),
            items: [
              { label: "Fatal", color: "#8b0000" },
              { label: "Serious injury", color: "#de3f53" },
              { label: "Minor Injury", color: "#ffa500" },
              { label: "Non-injury", color: "lightgrey" }
            ]
          }
        ]
      }}
      />
    </div>
    )
  }
}

export default StepChart


/*
 *false ?
      <div style={{position: 'relative'}}>
        <div style={{ position: 'absolute' }}>
          <XYFrame
            { ...common }
            points={noninjury}
          />
        </div>
        <div style={{ position: 'absolute' }}>
          <XYFrame
            { ...common }
            points={minor}
          />
        </div>
        <div style={{ position: 'absolute' }}>
          <XYFrame
            { ...common }
            points={serious}
          />
        </div>
        <div style={{ position: 'absolute' }}>
          <XYFrame
            { ...common }
            points={fatal}
          />
        </div>
      </div>
      :
      */    



// WEBPACK FOOTER //
// ./src/Crashes.js